'use client';

import { useId } from 'react';
import { BlockRoot } from '@akademi/site-builder-runtime';
import { SkBaseStyles, SkStyles } from '../styles/SkStyles';
import { headingLevel, SkLink } from './primitives';

/**
 * What a block shows when the data it works on does not exist in the shop yet
 * (a port with no adapter): its heading, one plain sentence, and a way to reach
 * a person. Never a preview, never example data.
 */
const CSS = `
.sk-notopen{padding-block:2.5rem 4rem}
.sk-notopen__box{max-width:44rem;display:grid;gap:1rem}
.sk-notopen__title{font-size:clamp(2rem,1.4rem + 2.2vw,3rem)}
.sk-notopen__actions{display:flex;flex-wrap:wrap;gap:.75rem;margin:0}
`;

export function NotOpen({
  title,
  message,
  level,
  contactHref = '/contact',
}: {
  title: string;
  message: string;
  level?: 'h1' | 'h2' | 'h3';
  contactHref?: string;
}) {
  const id = useId();
  const Heading = headingLevel(level, 'h1');
  return (
    <BlockRoot as="section" className="sk sk-notopen" aria-labelledby={id}>
      <SkBaseStyles />
      <SkStyles id="not-open" css={CSS} />
      <div className="sk-container sk-notopen__box">
        <Heading id={id} className="sk-heading sk-notopen__title">
          {title}
        </Heading>
        <p className="sk-lead">{message}</p>
        {contactHref && (
          <p className="sk-notopen__actions">
            <SkLink href={contactHref} className="sk-btn sk-btn--primary">
              Contact us
            </SkLink>
          </p>
        )}
      </div>
    </BlockRoot>
  );
}
